// Digits and the punctuation phone numbers are written with: "+1 (555) 123-4567", "555.123.4567"
const PHONE_NUMBER_CHARACTERS = /^[\d\s+().-]+$/;

/**
 * Reduces a phone number to the digits it is made of, so that numbers which only differ in
 * formatting - e.g. "+1 (555) 123-4567", "555-123-4567" and "5551234567" - can be matched
 * against each other.
 * A value holding anything beyond digits and phone punctuation is not a phone number at all -
 * an email address, a name - and reduces to an empty string, so that callers can tell apart
 * "no digits to compare" from "digits worth comparing". Without that distinction the stray
 * digit in an address like "ada3@mail.com" would reduce to "3" and match every phone number
 * containing a 3.
 * @param {string|number} phoneNumber the phone number to reduce
 * @returns {string} the digits of the phone number, in order, or '' if it is not a phone number
 */
const getPhoneNumberDigits = (phoneNumber) => {
  const value = phoneNumber ? phoneNumber.toString() : '';
  return PHONE_NUMBER_CHARACTERS.test(value) ? value.replace(/\D/g, '') : '';
};

export {
  getPhoneNumberDigits,
};
